<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">库区管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建停/开机计划</el-button
      >

      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入停/开机计划编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入创建人名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>

      <el-date-picker
        style="width: 300px; margin-left: 10px"
        v-model="searchData.CreateTime"
        value-format="yyyy-MM-dd"
        type="monthrange"
        range-separator="至"
        start-placeholder="创建开始日期"
        end-placeholder="创建结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <el-table-column
          label="停/开机计划编号"
          align="center"
          prop="Code"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="停/开机计划名称"
          align="center"
          prop="Name"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="计划开始日期"
          align="center"
          prop="StartTime"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.StartTime">{{
              moment(scope.row.StartTime).format('YYYY-MM-DD')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计划结束日期"
          align="center"
          prop="EndTime"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.EndTime">{{
              moment(scope.row.EndTime).format('YYYY-MM-DD')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开机时间"
          align="center"
          prop="PowerOnTime"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="停机时间"
          align="center"
          prop="ShutdownTime"
          sortable
        >
        </el-table-column>
        <el-table-column label="状态" align="center" prop="Status" sortable>
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.Status == 0">未开启</el-tag>
            <el-tag type="success" v-if="scope.row.Status == 1">已开启</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建日期"
          align="center"
          prop="CreateTime"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.CreateTime">{{
              moment(scope.row.CreateTime).format('YYYY-MM-DD')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人"
          align="center"
          prop="CreatorName"
          sortable
        >
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >详情</el-button
            >
            <!-- <el-button type="text" @click="handleCopy(scope.row)"
              >复制</el-button
            > -->
            <el-button
              type="text"
              style="color: #67c23a"
              @click="handleOpen(scope.row, 1)"
              v-if="scope.row.Status == 0"
              >开启计划</el-button
            >
            <el-button
              type="text"
              @click="handleOpen(scope.row, 0)"
              style="color: #e6a23c"
              v-if="scope.row.Status == 1"
              >关闭计划</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Status == 0"
              @click="handleDetele(scope.row)"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import EditForm from './EditForm'

import moment from 'moment'
export default {
  data() {
    return {
      moment,
      searchData: {
        Keyword: '',
        CreateTime: '',
        CreatorName: '',
        DeviceType: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      DictionaryMainList: [],
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'CreateTime', [firstDay, lastDay])
      }
    },
    handleOpen(row, Status) {
      this.$confirm(`是否确认开启该计划？`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              `/Base_DeviceTreeManage/device_stoptaskplan/DeviceStopTaskPlanSaveStatusData?Id=${row.Id}&Status=${Status}`,
              {}
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                if (Status == 1) {
                  this.$notify.success('开启计划成功')
                } else if (Status == 0) {
                  this.$notify.success('关闭计划成功')
                }

                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/device_stoptaskplan/GetDeviceStopTaskPlanDataList',
          {
            PageIndex: this.pagination.PageIndex,
            PageRows: this.pagination.PageRows,
            SortField: 'CreateTime',
            SortType: 'Desc',
            Search: [
              {
                Condition: 'CreateTime',
                Keyword: this.searchData.CreateTime
                  ? this.searchData.CreateTime.join(',')
                  : '',
              },
              {
                Condition: 'CreatorName',
                Keyword: this.searchData.CreatorName,
              },

              {
                Condition: 'Name',
                Keyword: this.searchData.Keyword,
              },
            ],
          }
        )
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建停/开机计划')
    },
    handleDetele(row) {
      this.$confirm(`此操作将永久删除该停/开机计划, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base_DeviceTreeManage/device_stoptaskplan/DeleteDeviceStopTaskPlanData?Id=' +
                row.Id,
              {}
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('开机计划详情/开机计划', row, false, true)
    },
    handleCopy(row) {
      this.$refs.EditForm.openForm('新建停/开机计划', row, true)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
